import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService, AlertService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { UserService } from '../../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-reports-configuration-accordion',
  templateUrl: './reports-configuration-accordion.component.html',
  styleUrls: ['./reports-configuration-accordion.component.css']
})
export class  ReportsConfigurationAccordionComponent extends AbstractFormWidgetComponent {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }


}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-accordion/reports-configuration-accordion.component.ts